import { autoinject, transient } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "@rightship-tech/common-ui/services/basic/notification-client.service";
import { DocumentManagementEntityTypeEnum } from "../../../models/document-management.models";
import { DocumentReviewApi } from "../../../apis/document-review.api";
import { ReviewClientModel } from "../../../models/document-review.models";
import { ValidationController, ValidationControllerFactory, ValidationRules } from "aurelia-validation";
import { CustomValidationRenderer } from "@rightship-tech/common-ui/client-validation-system/custom-validation-renderer";
import { GoogleAnalyticsService } from "@rightship-tech/common-ui/services/analytics/google-analytics.service";

@autoinject
@transient()
export class DialogReviewDocument {

    private _requirementName: string;
    private _requirementCustomerName: string;
    private _validator: ValidationController;
    public comments: string = "";
    public isMarkAsReviewed: boolean = false;
    public itemId: number;
    public typeId: number;
    onSave: (review: ReviewClientModel) => void;

    constructor(public dialogClientService: DialogClientService, private documentAccessApi: DocumentReviewApi, 
        private notificationClientService: NotificationClientService, private googleAnalyticsService: GoogleAnalyticsService, 
        private validationControllerFactory: ValidationControllerFactory) {
            this._validator  = this.validationControllerFactory.createForCurrentScope();
            this._validator.addRenderer(new CustomValidationRenderer());
            this.setValidationRules();
        }

    activate(model: { isMarkAsReviewed: boolean, itemId: number, typeId: number, requirementName: string, 
        requirementCustomerName: string, onSave: (review: ReviewClientModel) => void }) {
        this.isMarkAsReviewed = model.isMarkAsReviewed;
        this.itemId = model.itemId;
        this.typeId = model.typeId;
        this._requirementName = model.requirementName;
        this._requirementCustomerName = model.requirementCustomerName;
        this.onSave = model.onSave;
    }

    private setValidationRules() 
    {
        var rules = ValidationRules.ensure<DialogReviewDocument, string>(x => x.comments)
            .required()
            .when(x => x.isMarkAsReviewed)
            .withMessage("Comments is required")
            .on(this);
    }

    //save
    async save() {
        try {
            const validation = await this._validator.validate();
            if (!validation.valid) {
                return;
            }

            let review: ReviewClientModel;
            if (this.typeId == DocumentManagementEntityTypeEnum.VesselForm) {
                review = await this.documentAccessApi.saveFormReview({
                    vesselFormId : this.itemId,
                    comments : this.comments,
                    isReview : this.isMarkAsReviewed
                })
            }
            else {
                review = await this.documentAccessApi.saveDocumentReview({
                    vesselDocumentId : this.itemId,
                    comments : this.comments,
                    isReview : this.isMarkAsReviewed
                })
            }
            if(this.onSave) {
                this.onSave(review);
            }
            this.notificationClientService.show("Review has been saved successfully", "", NotificationType.Success);

            //Send event to google analytics
            this.googleAnalyticsService.sendCustomGA4EventMulti("dmc_document_review_mark_as_" + this.isMarkAsReviewed ? 'reviewed':'unreviewed', {
                "charterer": this._requirementCustomerName, 
                "documentType": this._requirementName 
            });

            //Hide dialog
            this.dialogClientService.hide(true);
        }
        catch (error) {
            console.log(error)
            this.notificationClientService.show("An error occurd when trying to save review", "", NotificationType.Error);
        }
    }

    //Cancel
    cancel() {
        this.dialogClientService.hide();
    }
}